import session from '@api/session'
import { APIEndpoint } from '@api/_version'

export default {
  getCampaignStats(uuid, fromDate, toDate) {
    return session.get(
      APIEndpoint +
      `/api/analytics/campaigns/${uuid}/` +
      (fromDate ? `?from=${fromDate}` : '') +
      (toDate ? `&to=${toDate}` : ''),
    )
  },
  getAllCampaignsStats() {
    return session.get(APIEndpoint + `/api/analytics/campaigns/`)
  },
  getCampaignResponses(uuid, size, pageNumber, sortBy, targetStats) {
    const queryParams = []

    if (size !== null && size) {
      queryParams.push(`size=${size}`)
    }
    if (pageNumber !== null && pageNumber) {
      queryParams.push(`page=${pageNumber}`)
    }
    if (sortBy !== null && sortBy) {
      queryParams.push(`sort=${sortBy}`)
    }
    if (targetStats !== null && targetStats) {
      queryParams.push(`target=${targetStats}`)
    }

    const queryString = queryParams.length ? '?' + queryParams.join('&') : ''

    return session.get(
      APIEndpoint + `/api/analytics/campaigns/${uuid}/feedback/` + queryString,
    )
  },
  downloadCampaignStats(uuid) {
    return session({
      url: APIEndpoint + `/api/analytics/campaigns/${uuid}/download/`,
      method: 'get',
      responseType: 'blob',
    })
  },
  downloadCampaignEmails(uuid) {
    return session({
      url: APIEndpoint + `/api/analytics/campaigns/${uuid}/emails/`,
      method: 'get',
      responseType: 'blob',
    })
  },
}
